import { StatusCodes } from '@guiker/http'

import Dictionary from '../dictionary'

export default class BaseError extends Error {
  errorCode: string

  constructor(
    public message: string,
    public name: string,
    public statusCode: number = StatusCodes.INTERNAL_SERVER_ERROR,
    public meta: unknown = {},
  ) {
    super(message)
    this.name = name
    this.errorCode = name
    this.meta = meta
  }

  toDict(): Dictionary {
    return {
      message: this.message,
      errorCode: this.name,
      statusCode: this.statusCode,
      meta: this.meta,
    }
  }
}
